import ComplaintTrackingDetail from 'components/viewComplaintTracking/ComplaintTrackingDetail.component';

const ViewComplaintTrackingDetailPage = ({
	isComplaintDetails,
}: {
	isComplaintDetails: boolean;
}) => {
	return <ComplaintTrackingDetail isComplaintDetails={isComplaintDetails} />;
};

export default ViewComplaintTrackingDetailPage;
